import { readable, get } from 'svelte/store';


import { agent, version, stage } from '@/config';


const { subscribe } = readable({
	agent: agent,
	version: version,
	stage: stage,
});


export const client = {
	subscribe,

	/* pull */
	pull: prop =>
		prop ? get(client)[prop] : get(client),
};
